import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/identity-and-access/companies/")({
  staticData: {
    title: "companies.title",
  },
});
